import { OfficeNote as OfficeNoteType } from '@weave/schema-gen-ts/dist/schemas/forms-digital/weave_digital_forms.pb';
import { useTranslation } from '@frontend/i18n';
import { Heading, Text } from '@frontend/design-system';
import { containerStyle, headingStyle, valueStyle } from './office-note.styles';

interface OfficeNoteProps {
  officeNote?: OfficeNoteType | null;
}

export const OfficeNote = ({ officeNote }: OfficeNoteProps) => {
  const { t } = useTranslation('digital-forms-experience');

  if (!officeNote?.value) return null;

  return (
    <div css={containerStyle}>
      <Heading level={3} as='h2' css={headingStyle}>
        {officeNote.label || t('For Office Use Only')}
      </Heading>
      <Text css={valueStyle}>{officeNote.value}</Text>
    </div>
  );
};
